import { Box } from "@mui/material";
import React from "react";
import logo from "../../assets/images/logo.png";
const Logo = () => {
  return (
    <Box class="logo">
      <img src={logo}></img>
    </Box>
  );
};

export default Logo;
